// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
import { Button } from '@/common-utils/components/ui/button';
// Common
import ICONS from '@/common-utils/enums/icons';

/**
 * @param {Object} props
 * @param {string} props.entity
 * @param {string} props.buttonEntity
 * @param {function} props.onClick
 * @param {string} props.namespace
 * @returns {JSX} CardRedirection
 */
function CardRedirection({ buttonEntity, onClick, namespace }) {
    return (
        <div className='flex items-center justify-center min-h-[200px] flex-col gap-2'>
            <Entity
                className='text-md font-medium text-muted-foreground'
                entity='Echec du chargement des données'
            />
            <Button
                className='flex flex-row-reverse gap-1'
                icon={ICONS.REDIRECT}
                entity={buttonEntity}
                namespace={namespace}
                onClick={onClick}
            />
        </div>
    );
}

CardRedirection.propTypes = {
    buttonEntity: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    namespace: PropTypes.string
};

export default CardRedirection;